document.addEventListener("DOMContentLoaded", () => {
    const accordions = document.querySelectorAll('.Accordion');

    accordions.forEach((accordion) => {
        const blocks = accordion.querySelectorAll('.Accordion_Block');

        blocks.forEach((block) => {
            const header = block.querySelector('.Accordion_Title');
            const content = block.querySelector('.Accordion_Content');
            content.style.setProperty('--height', `${content.scrollHeight}px`);

            header.addEventListener('click', () => {
                if (block.classList.contains('Open')) {
                    block.classList.remove('Open');
                } else {
                    blocks.forEach((b) => {
                        b.classList.remove('Open');
                    });
                    block.classList.add('Open');
                }
            });

            window.addEventListener('resize', () => {
                content.style.setProperty('--height', `${content.scrollHeight}px`);
            });
        });
    });
});